var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"beach"},[_c('div',{staticClass:"beach__label"},[_vm._v("Plaża")]),_vm._v(" "),_c('CheckList',{staticClass:"beach__body",attrs:{"value":_vm.value}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eca000f2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/fields/BeachDropdown.vue
// module id = 822
// module chunks = 1